import type { Entity } from '@backstage/catalog-model';
import { EntityTypeFilter } from '@backstage/plugin-catalog-react';

import { ALLOWED_DAAS_TYPES, type DaaSType } from '../../types';


export class DaaSTypeTabFilter extends EntityTypeFilter {
  constructor(readonly selectedType: DaaSType) {
    super(selectedType);
  }

  getCatalogQuery() {
    return { 'spec.type': { $in: [...ALLOWED_DAAS_TYPES] } };
  }

  getCatalogFilters(): Record<string, string[]> {
    return { 'spec.type': [...ALLOWED_DAAS_TYPES] };
  }

  filterEntity(entity: Entity): boolean {
    return entity.spec?.type === this.selectedType;
  }
}
